import { __decorate } from "tslib";
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let SpaceLabelsModelImpl = class SpaceLabelsModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = [];
    }
    dispose() {
        this.update(() => []);
    }
};
SpaceLabelsModelImpl = __decorate([
    injectable()
], SpaceLabelsModelImpl);
export { SpaceLabelsModelImpl };
